<template>
  <div class="con-wrap">
    <p class="box-title">保养记录</p>
    <div class="data-wrap">
      <div class="query-box">
        <el-form size="mini" :inline="true">
          <el-form-item>
            <el-date-picker
              v-model="queryDate"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form>
      </div>
      <div class="data-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          stripe
          height="560px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="35"
          ></el-table-column>
          <el-table-column
            width="150"
            prop="addTime"
            label="操作时间"
          ></el-table-column>
          <el-table-column
            prop="operatorName"
            label="操作人员"
            min-width="90"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="使用人"
            min-width="90"
            prop="ownerName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="curMileage"
            min-width="180"
            label="行驶里程记录（km）"
          ></el-table-column>
          <template v-if="version == 1">
            <el-table-column
              prop="rMaintenanceMileage"
              min-width="200"
              label="重置剩余保养里程记录（km）"
            ></el-table-column>
            <el-table-column
              prop="residuePowerTakeoff"
              min-width="220"
              label="重置取力器保养里程记录（km）"
            ></el-table-column>
            <el-table-column
              prop="residueGearbox"
              min-width="220"
              label="重置变速箱保养里程记录（km）"
            ></el-table-column>
          </template>
          <template v-else-if="version == 2">
            <el-table-column
              prop="rangeExtender"
              min-width="240"
              label="重置增程器剩余保养里程记录(km)"
            ></el-table-column>
            <el-table-column
              prop="rearAxleDifferential"
              min-width="260"
              label="重置后桥差速器剩余保养里程记录(km)"
            ></el-table-column>
          </template>

          <el-table-column
            prop="curEnergy"
            min-width="200"
            label="重置电表发电量记录（kW·h）"
          ></el-table-column>
          <el-table-column width="260" prop="type" label="记录类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">重置保养里程</span>
              <span v-if="scope.row.type == 2">校准保养里程</span>
              <span v-if="scope.row.type == 3">更换电表</span>
              <span v-if="scope.row.type == 4">重置取力器</span>
              <span v-if="scope.row.type == 5">重置保养里程、重置取力器</span>
              <span v-if="scope.row.type == 8">重置变速箱</span>
              <span v-if="scope.row.type == 9">重置保养里程、重置变速箱</span>
              <span v-if="scope.row.type == 12">重置取力器、重置变速箱</span>
              <span v-if="scope.row.type == 13"
                >重置保养里程、重置取力器、重置变速箱</span
              >
              <span v-if="scope.row.type == 16">更换取力器</span>
              <span v-if="scope.row.type == 17">重置保养里程、更换取力器</span>
              <span v-if="scope.row.type == 32">更换变速箱</span>
              <span v-if="scope.row.type == 33">重置保养里程、更换变速箱</span>
              <span v-if="scope.row.type == 49"
                >重置保养里程、更换取力器、更换变速箱</span
              >
              <span v-if="scope.row.type == 384"
                >重置后桥差速器、更换增程器</span
              >
              <span v-if="scope.row.type == 576"
                >重置增程器、更换后桥差速器</span
              >
              <span v-if="scope.row.type == 64">重置增程器</span>
              <span v-if="scope.row.type == 128">重置后桥差速器</span>
              <span v-if="scope.row.type == 192"
                >重置增程器、重置后桥差速器</span
              >
              <span v-if="scope.row.type == 512">更换后桥差速器</span>
              <span v-if="scope.row.type == 256">更换增程器</span>
              <span v-if="scope.row.type == 768"
                >更换增程器、更换后桥差速器</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintainRecord",
  props: {
    vin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      queryDate: "",
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
      version: null,
    };
  },
  created() {
    let version =
      sessionStorage.getItem("version") ||
      this.$store.state.VehicleFormData.version;
    this.version = version;
  },
  mounted() {
    this.getRefuelingData();
  },
  methods: {
    query() {
      this.getRefuelingData();
    },
    reset() {
      this.$resetForm(this, "queryDate");
      this.getRefuelingData();
    },
    async getRefuelingData() {
      let _this = this;
      let obj = {
        vin: _this.vin,
        date: _this.queryDate,
        page: _this.currentPage,
        limit: _this.limit,
      };
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/maintain/resets",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRefuelingData();
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: 100%;
  margin: 0;
  background-color: #fff;
}
.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}
.data-wrap {
  width: 100%;
  height: calc(100% - 31px);
  padding: 20px;
  box-sizing: border-box;
}
.data-box {
  width: 100%;
  height: calc(100% - 84px);
}
#open-map {
  width: 100%;
  height: 580px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}
</style>
